import { isBoolean, isString } from '../../../utils';

// TODO remove redundant parse
export const parse = (value) => (value || isBoolean(value) ? [value] : '');

export const parseCheckbox = (value) => [value];

export const parseObject = (value) => value || {};

export const parseMultiSelect = (value) => (value && value.length ? value : '');

export const format = (value) => {
  if (value && value.length) {
    const extractedValue = value[0];
    return extractedValue || isBoolean(extractedValue) ? extractedValue : '';
  }
  return '';
};

export const formatObject = (value) => value || {};

export const formatCheckbox = (value) => (value ? value[0] : false);

export const getQuestionNameFromFieldName = (reduxFieldName) =>
  reduxFieldName && reduxFieldName.includes('.') ? reduxFieldName.split('.').pop() : reduxFieldName;

export const formatValueToString = (defaultValue) => (value) => {
  if (isString(value)) {
    return value;
  }

  return JSON.stringify(value || defaultValue);
};
